import React from 'react';
import { Link } from 'react-router-dom';
import { useScrollReveal } from '../../../hooks/useScrollReveal';

interface ContactCTAProps {
  isLoaded: boolean;
}

const ContactCTA: React.FC<ContactCTAProps> = ({ isLoaded }) => {
  const { ref, isVisible } = useScrollReveal<HTMLDivElement>();

  return (
    <section
      ref={ref}
      className={`contact-cta scroll-reveal ${isVisible ? 'is-visible' : ''} ${isLoaded ? 'animate-in' : ''}`}
      aria-labelledby="contact-cta-heading"
    >
      <h2 id="contact-cta-heading" className="contact-cta__heading">
        Let&apos;s Build Something
      </h2>
      <p className="contact-cta__subline">
        Open to new opportunities and collaborations
      </p>
      <Link to="/contact" className="contact-cta__button recruit-button">
        Get In Touch →
      </Link>
    </section>
  );
};

export default React.memo(ContactCTA);
